import { hasOnboardingConnectionProgress } from '~/utils/bankAccountLinkStatus';
import type { PaymentMode } from '~/hooks/usePaymentMode';
import type { HydratedBankAccountDto } from '~/swagger/portal/Api';

type NeedsBankAccountSetupParams = {
  getAccounts: () => HydratedBankAccountDto[] | null | undefined;
  refetchAccounts: () => Promise<HydratedBankAccountDto[] | null | undefined>;
  paymentMode: PaymentMode;
};

export const checkNeedsBankAccountSetup = async ({
  getAccounts,
  refetchAccounts,
  paymentMode,
}: NeedsBankAccountSetupParams): Promise<boolean> => {
  const cachedAccounts = getAccounts() ?? [];

  if (hasOnboardingConnectionProgress(cachedAccounts, paymentMode)) {
    return false;
  }

  const refreshedAccounts = (await refetchAccounts()) ?? getAccounts() ?? [];
  return !hasOnboardingConnectionProgress(refreshedAccounts, paymentMode);
};
